import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  availableFilters: [],
  appliedFilters: {},
  pendingFilters: {},
  facetData: {},
  facetDataLoaded: false,
  facetDataLoadedAt: null,
  dateFilters: {},
  pendingDateFilters: {},
  loading: false,
  error: null,
  projectId: '0000000093'
};

const filterSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setAvailableFilters: (state, action) => {
      state.availableFilters = action.payload;
    },
    setFacetData: (state, action) => {
      state.facetData = { ...state.facetData, ...action.payload };
      state.facetDataLoaded = true;
      state.facetDataLoadedAt = Date.now();
    },
    addFilter: (state, action) => {
      const { fieldName, value } = action.payload;
      if (!state.appliedFilters[fieldName]) {
        state.appliedFilters[fieldName] = [];
      }
      if (!state.appliedFilters[fieldName].includes(value)) {
        state.appliedFilters[fieldName].push(value);
      }
    },
    removeFilter: (state, action) => {
      const { fieldName, value } = action.payload;
      if (state.appliedFilters[fieldName]) {
        state.appliedFilters[fieldName] = state.appliedFilters[fieldName].filter(
          v => v !== value
        );
        if (state.appliedFilters[fieldName].length === 0) {
          delete state.appliedFilters[fieldName];
        }
      }
    },
    addPendingFilter: (state, action) => {
      const { fieldName, value } = action.payload;
      if (!state.pendingFilters[fieldName]) {
        state.pendingFilters[fieldName] = [];
      }
      if (!state.pendingFilters[fieldName].includes(value)) {
        state.pendingFilters[fieldName].push(value);
      }
    },
    removePendingFilter: (state, action) => {
      const { fieldName, value } = action.payload;
      if (state.pendingFilters[fieldName]) {
        state.pendingFilters[fieldName] = state.pendingFilters[fieldName].filter(
          v => v !== value
        );
        if (state.pendingFilters[fieldName].length === 0) {
          delete state.pendingFilters[fieldName];
        }
      }
    },
    applyPendingFilters: (state) => {
      state.appliedFilters = { ...state.pendingFilters };
      state.dateFilters = { ...state.pendingDateFilters };
    },
    initializePendingFilters: (state) => {
      state.pendingFilters = { ...state.appliedFilters };
      state.pendingDateFilters = { ...state.dateFilters };
    },
    clearPendingFilters: (state) => {
      state.pendingFilters = {};
      state.pendingDateFilters = {};
    },
    resetPendingToApplied: (state) => {
      state.pendingFilters = { ...state.appliedFilters };
      state.pendingDateFilters = { ...state.dateFilters };
    },
    clearFieldFilters: (state, action) => {
      const fieldName = action.payload;
      delete state.appliedFilters[fieldName];
    },
    clearAllFilters: (state) => {
      state.appliedFilters = {};
      state.dateFilters = {};
    },
    setDateFilter: (state, action) => {
      const { fieldName, startDate, endDate } = action.payload;
      if (!startDate && !endDate) {
        delete state.dateFilters[fieldName];
      } else {
        state.dateFilters[fieldName] = { startDate, endDate };
      }
    },
    setPendingDateFilter: (state, action) => {
      const { fieldName, startDate, endDate } = action.payload;
      if (!startDate && !endDate) {
        delete state.pendingDateFilters[fieldName];
      } else {
        state.pendingDateFilters[fieldName] = { startDate, endDate };
      }
    },
    removeDateFilter: (state, action) => {
      const fieldName = action.payload;
      delete state.dateFilters[fieldName];
    },
    clearFacetData: (state) => {
      state.facetData = {};
      state.facetDataLoaded = false;
      state.facetDataLoadedAt = null;
    },
    setProjectId: (state, action) => {
      state.projectId = action.payload;
      state.availableFilters = [];
      state.appliedFilters = {};
      state.pendingFilters = {};
      state.facetData = {};
      state.facetDataLoaded = false;
      state.facetDataLoadedAt = null;
      state.dateFilters = {};
      state.pendingDateFilters = {};
    }
  },
});

export const {
  setLoading,
  setError,
  setAvailableFilters,
  setFacetData,
  clearFacetData,
  addFilter,
  removeFilter,
  addPendingFilter,
  removePendingFilter,
  applyPendingFilters,
  initializePendingFilters,
  clearPendingFilters,
  resetPendingToApplied,
  clearFieldFilters,
  clearAllFilters,
  setDateFilter,
  setPendingDateFilter,
  removeDateFilter,
  setProjectId
} = filterSlice.actions;

export const selectFilters = (state) => state.filters;
export const selectAppliedFilters = (state) => state.filters.appliedFilters;
export const selectPendingFilters = (state) => state.filters.pendingFilters;
export const selectDateFilters = (state) => state.filters.dateFilters;
export const selectPendingDateFilters = (state) => state.filters.pendingDateFilters;
export const selectAvailableFilters = (state) => state.filters.availableFilters;
export const selectFacetData = (state) => state.filters.facetData;
export const selectFacetDataLoaded = (state) => state.filters.facetDataLoaded;
export const selectFacetDataLoadedAt = (state) => state.filters.facetDataLoadedAt;
export const selectFiltersLoading = (state) => state.filters.loading;
export const selectFiltersError = (state) => state.filters.error;
export const selectProjectId = (state) => state.filters.projectId;

export default filterSlice.reducer;